module.exports = __webpack_public_path__ + "be.f9d78d777f589b4a8848.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/be.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/be.svg
// module chunks = styles